import { buildQueries } from '@testing-library/react';
import $ from 'jquery';

// // The issue is likely here - httpRequest needs to be declared before use
// export function buildHttpRequest(method, url, params, callback) {
//     // Declare httpRequest first
//     let httpRequest = new XMLHttpRequest();
    
//     if (!httpRequest) {
//         alert('Cannot create an XMLHTTP instance');
//         return false;
//     }
    
//     // Set up the callback
//     httpRequest.onreadystatechange = function() {
//         if (callback) {
//             callback(httpRequest);  // Pass httpRequest to callback
//         }
//     };
    
//     // Configure the request
//     httpRequest.open(method, url);
    
//     // Return the configured request
//     return httpRequest;
// }

function buildUrl(path, requestParams) {
    let url = path;
    if (requestParams) {
        let isFirst = true;
        for (let [key, value] of requestParams) {
            console.log(key + " = " + value);
            if (isFirst) {
                url += "?";
            } else {
                url += "&";
            }
            url += key + "=";
            url += encodeURIComponent(value);
            isFirst = false;
        }
    }
    console.log("url: " + url);
    return url;
}

function buildHttp(type, url, params, callback, body) {
    // Build the URL with base path
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:40383/';
    const urlWithParams = buildUrl(baseUrl + url, params);

    // Create the request
    let httpRequest = new XMLHttpRequest();
    
    if (!httpRequest) {
        alert('Cannot create an XMLHTTP instance');
        return false;
    }
    
    // Set up the state change handler
    httpRequest.onreadystatechange = function() {
        if (httpRequest.readyState === XMLHttpRequest.DONE) {
            // Call the callback when request is done
            if (callback) {
                callback(httpRequest);
            }
        }
    };
    
    // Open the connection
    httpRequest.open(type, urlWithParams);
    httpRequest.setRequestHeader('Content-Type', 'application/json');

    // Add send method to the request object
    httpRequest.sendRequest = function() {
        if (body) {
            // httpRequest.body = body;
            this.send(body);
        } else {
            this.send();
        }
    };

    return httpRequest;
}

export function buildHttpPost(url, params, callback) {
    return buildHttp('POST', url, params, callback, null);
}

export function buildHttpPostWithBody(url, params, callback, body) {
    return buildHttp('POST', url, params, callback, body);
}

export function buildHttpGet(url, params, callback) {
    return buildHttp('GET', url, params, callback, null);
}

export function buildHttpGetWithBody(url, params, callback, body) {
    return buildHttp('GET', url, params, callback, body);
}
